module.exports = __webpack_public_path__ + "img/HKAEE.9347ffcd.png";